import { FC, useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
} from "@material-ui/core";
import Axios from "axios";
import { Form, Formik, FormikHelpers } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import { useStyles } from "../../shared/styles/useStyles";
import * as yup from "yup";
import { MyTextField } from "../custom/MyTextField";
import { TextField } from "@material-ui/core";
import clsx from "clsx";
import {
  getEntity,
  validateEmailInMailjet,
} from "../../services/firebase/entities";
import { MyAlert } from "../custom/MyAlert";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducers/rootReducer";
import { TypeEntity } from "../../enums/enums";
import {
  addEntity,
  editEntity,
  purgeActiveEntity,
} from "../../redux/actions/entitiesActions";
import {
  uiCloseModalAdd,
  uiCloseModalEdit,
  uiOpenErrorAlert,
  uiOpenSuccessAlert,
} from "../../redux/actions/uiActions";
import { uiCloseErrorAlert, setErrorMsg } from "../../redux/actions/uiActions";
import {
  getCitiesTwo,
  getCountriesTwo,
  getStatesTwo,
} from "../../utils/country/service/getInfoCountry";
import { ICountry } from "../../utils/country/interfaces/ICountry";
import { IState } from "../../utils/country/interfaces/IStates";
import { ICity } from "../../utils/country/interfaces/ICity";
import { IAuthDoc } from "../../module/auth/doc/IAuthDoc";
import {
  saveEmailPasswordService,
  updateCredentialsEntityService,
} from "../../module/auth/firebase/AuthService";
import { IAuthChangePassword } from "../../module/auth/doc/IAuthChangePassword";
import {
  createEntity,
  updateEntity,
} from "../../module/superAdmin/firebase/EntityService";
import { EntityForm } from "../../module/superAdmin/form/EntityFrom";

interface EntityFormProps {
  edit?: boolean;
}

export const FormEntity: FC<EntityFormProps> = ({ edit = false }) => {
  const intl = useIntl();
  const classes = useStyles();
  const { errorAlert, errorMsg } = useSelector((state: AppState) => state.ui);

  const [countries, setCountries] = useState<ICountry[]>([]);
  const [countrySelected, setCountrySelected] = useState("");

  const [departmentSelected, setDepartmentSelected] = useState<string>("");
  const [departments, setDepartments] = useState<IState[]>([]);

  const [townSelected, setTownSelected] = useState("");
  const [filteredTowns, setFilteredTowns] = useState<ICity[]>([]);

  const { activeEntity } = useSelector((state: AppState) => state.entities);
  const [oldCredentials, setOldCredentials] = useState<IAuthDoc | null>(null);
  const [showExistAlert, setShowExistAlert] = useState(false);
  const [entityTypeSelected, setEntityTypeSelected] = useState<TypeEntity>(
    TypeEntity.PUBLIC
  );
  const [tokenApi, setTokenApi] = useState<string | null>(null);
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState<Partial<EntityForm>>({
    businessName: activeEntity !== null ? activeEntity.businessName : "",
    nit: activeEntity !== null ? activeEntity.nit : "",
    address: activeEntity !== null ? activeEntity.address : "",
    phone: activeEntity !== null ? activeEntity.mobilePhone : "",
    department: activeEntity !== null ? activeEntity.department : "",
    town: activeEntity !== null ? activeEntity.town : "",
    sigepCode: activeEntity !== null ? activeEntity.sigepCode : "",
    daneCode: activeEntity !== null ? activeEntity.daneCode : "",
    firstName: activeEntity !== null ? activeEntity.firstName : "",
    secondName: activeEntity !== null ? activeEntity.secondName : "",
    surname: activeEntity !== null ? activeEntity.surname : "",
    secondSurname: activeEntity !== null ? activeEntity.secondName : "",
    email: activeEntity !== null ? activeEntity.email : "",
    emailSender: "comercial@appsus.co",
    id: activeEntity !== null ? activeEntity.id : "",
    country: activeEntity !== null ? activeEntity.country : "",
  });

  const validationSchema = yup.object({
    businessName: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    nit: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`)
      .min(8, `${intl.formatMessage({ id: "MinimumPassword" })}`),
    address: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    phone: yup
      .number()
      .typeError(`${intl.formatMessage({ id: "NumericValue" })}`)
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    firstName: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    surname: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    email: yup
      .string()
      .email(`${intl.formatMessage({ id: "InvalidEmail" })}`)
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    emailSender: yup
      .string()
      .email(`${intl.formatMessage({ id: "InvalidEmail" })}`)
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    id: yup
      .string()
      .typeError(`${intl.formatMessage({ id: "NumericValue" })}`)
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`)
      .min(5, `${intl.formatMessage({ id: "MinimumDocument" })}`),
  });

  const handleCreateEntity = async (entity: EntityForm) => {
    try {
      //const { email, id, nit, emailSender } = entity;
      // const isMailInMailjet = await validateEmailInMailjet(emailSender);
      // if (!isMailInMailjet) {
      //   dispatch(setErrorMsg("SenderIsNotInMailjet"));
      //   dispatch(uiOpenErrorAlert());
      //   return null;
      // }

      if (!edit && !oldCredentials) {
        create(entity);
      } else {
        update(entity);
      }
      
      await dispatch(uiOpenSuccessAlert());
      dispatch(purgeActiveEntity());
      dispatch(uiCloseModalAdd());
      dispatch(uiCloseModalEdit());
    } catch (error) {
      dispatch(uiOpenErrorAlert());
    }
  };

  const create = async (dataSave: EntityForm) => {
    const existsEntity = await getEntity(dataSave.nit);
    if (existsEntity) {
      return setShowExistAlert(true);
    }

    let register: IAuthDoc = {
      password: dataSave.id,
      email: dataSave.email,
    };
    let data: any = await saveEmailPasswordService(register);
    dataSave.uid = data.localId;
    createEntity({ ...dataSave, active: true });
    dispatch(addEntity(dataSave));
  };

  const update = async (dataSave: EntityForm) => {
    
    if (!oldCredentials) {
      return setShowExistAlert(true);
    }
    dataSave.active = true;
    let autchange: IAuthChangePassword = {
      oldPassword: oldCredentials.password,
      newPassword: dataSave.id,
      email: oldCredentials.email,
    };
    const data = await updateCredentialsEntityService(autchange);
    dataSave.uid = data.localId;
    await updateEntity(dataSave);
    dispatch(editEntity({ ...dataSave }));
  };

  // country data is gotten
  useEffect(() => {
    const fetchData = async () => {
      let countryList = await getCountriesTwo();
      setCountries(countryList);
      if (edit) {
        if (!activeEntity) {
          return uiOpenErrorAlert();
        }
        let IAuthDocEdit: IAuthDoc = {
          password: activeEntity.id.toString(),
          email: activeEntity.email,
        };
        setEntityTypeSelected(activeEntity.entityType);
        setOldCredentials(IAuthDocEdit);

        let country = countryList.find(
          (data) => data.name === activeEntity.country
        );
        setCountrySelected(country.id);
      }
    };

    fetchData();
  }, []);

  const handleSelectCountry = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDepartmentSelected("");
    setTownSelected("");
    setCountrySelected(event.target.value);
  };

  //  Departments data is gotten
  useEffect(() => {
    if (countrySelected) {
      const fetchData = async () => {
        let states = await getStatesTwo(countrySelected);
        setDepartments(states);
        if (edit) {
          let department = states.find(
            (data) => data.name === activeEntity?.department
          );
          if (department) setDepartmentSelected(department.id);
        }
      };
      fetchData();
    }
  }, [countrySelected]);

  const handleSelectDepartment = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTownSelected("");
    setDepartmentSelected(event.target.value);
  };

  useEffect(() => {
    if (departmentSelected) {
      const fetchData = async () => {
        let cities = await getCitiesTwo(countrySelected, departmentSelected);
        setFilteredTowns(cities);
        if (edit) {
          let city = cities.find((data) => data.name === activeEntity?.town);
          if (city) setTownSelected(city.id);
        }
      };
      fetchData();
    }
  }, [departmentSelected]);

  const onClose = () => {
    dispatch(uiCloseModalAdd());
    dispatch(uiCloseModalEdit());
    dispatch(purgeActiveEntity());
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting }: FormikHelpers<any>
  ) => {
    setSubmitting(true);

    values.entityType = entityTypeSelected;

    let country = countries.find((data) => data.id === countrySelected);
    values.country = country?.name;

    let depto = departments.find((data) => data.id === departmentSelected);
    values.department = depto?.name;

    let city = filteredTowns.find((data) => data.id === townSelected);
    values.town = city?.name;

    await handleCreateEntity(values as EntityForm);
    setSubmitting(false);
  };

  return (
    <Box m={1}>
      <Formik
        enableReinitialize
        validateOnChange
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnMount
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form className={classes.input}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormattedMessage id="BusinessName" />*
                <MyTextField
                  name="businessName"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="Nit" />*
                <MyTextField
                  name="nit"
                  variant="outlined"
                  disabled={edit}
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="Address" />*
                <MyTextField
                  name="address"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="Phone" />*
                <MyTextField
                  name="phone"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="Country" />
                <TextField
                  size="small"
                  name="country"
                  variant="outlined"
                  select
                  disabled={edit}
                  value={countrySelected || ""}
                  onChange={handleSelectCountry}
                  className={classes.myTextFieldRoot}
                  autoComplete="off"
                >
                  {countries.map((country) => (
                    <MenuItem key={`${country.id}`} value={country.id}>
                      {country.translations.es}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="Department" />
                <TextField
                  size="small"
                  name="department"
                  variant="outlined"
                  select
                  // disabled={edit}
                  value={departmentSelected || ""}
                  onChange={handleSelectDepartment}
                  className={classes.myTextFieldRoot}
                  autoComplete="off"
                >
                  {departments.map((department) => (
                    <MenuItem key={department.id} value={department.id}>
                      {department.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="Town" />
                <TextField
                  size="small"
                  name="town"
                  variant="outlined"
                  select
                  // disabled={edit}
                  value={townSelected || ""}
                  onChange={(e: any) => setTownSelected(e.target.value)}
                  className={classes.myTextFieldRoot}
                >
                  {filteredTowns.map((town) => (
                    <MenuItem key={town.id} value={town.id}>
                      <p>{town.name}</p>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="SigepCode" />
                <MyTextField
                  name="sigepCode"
                  variant="outlined"
                  // disabled={edit}
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="DaneCode" />
                <MyTextField
                  name="daneCode"
                  variant="outlined"
                  // disabled={edit}
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="EmailForReceiveCommunications" />*
                <MyTextField
                  name="emailSender"
                  variant="outlined"
                  // disabled={edit}
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={12}>
                <FormattedMessage id="EntityType" />
                <TextField
                  size="small"
                  name="entityType"
                  variant="outlined"
                  select
                  value={entityTypeSelected}
                  onChange={(e: any) => setEntityTypeSelected(e.target.value)}
                  className={classes.myTextFieldRoot}
                >
                  <MenuItem value={TypeEntity.PUBLIC}>
                    <p>{TypeEntity.PUBLIC}</p>
                  </MenuItem>
                  <MenuItem value={TypeEntity.PRIVATE}>
                    <p>{TypeEntity.PRIVATE}</p>
                  </MenuItem>
                </TextField>
              </Grid>

              {/* DATOS DEL ADMIN */}
              <Grid item xs={12}>
                <h4>{<FormattedMessage id="SystemAdmin" />}</h4>
                <Divider light />
              </Grid>

              <Grid item xs={6}>
                <FormattedMessage id="FirstName" />*
                <MyTextField
                  name="firstName"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                />
              </Grid>

              <Grid item xs={6}>
                <FormattedMessage id="SecondName" />
                <MyTextField
                  name="secondName"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                />
              </Grid>

              <Grid item xs={6}>
                <FormattedMessage id="FirstLastName" />*
                <MyTextField
                  name="surname"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                />
              </Grid>

              <Grid item xs={6}>
                <FormattedMessage id="SecondLastName" />
                <MyTextField
                  name="secondSurname"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="Email" />*
                <MyTextField
                  name="email"
                  variant="outlined"
                  className={classes.myTextFieldRoot}
                  disabled={edit}
                />
              </Grid>
              <Grid item xs={6}>
                <FormattedMessage id="DocumentNumber" />*
                <MyTextField
                  name="id"
                  variant="outlined"
                  type="number"
                  disabled={edit}
                  className={classes.myTextFieldRoot}
                />
              </Grid>
              <Box
                mt={2}
                width={1}
                display="flex"
                justifyContent="flex-start"
                flexDirection="row-reverse"
              >
                {!isSubmitting ? (
                  <Button
                    className={clsx(classes.btn, classes.save)}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    <FormattedMessage id="Save" />
                  </Button>
                ) : (
                  <Button
                    className={clsx(classes.btn, classes.save)}
                    autoFocus
                    type="button"
                    disabled={true}
                  >
                    <CircularProgress className={classes.btnLoading} />
                  </Button>
                )}
                <Button
                  className={clsx(classes.btn, classes.cancel)}
                  onClick={onClose}
                >
                  <FormattedMessage id="Cancel" />
                </Button>
              </Box>
            </Grid>
          </Form>
        )}
      </Formik>

      <Box mt={3}>
        <MyAlert
          open={showExistAlert}
          typeAlert="error"
          message="ExistsEntity"
          time={3000}
          handleClose={() => setShowExistAlert(false)}
        />

        <MyAlert
          open={errorAlert}
          typeAlert="error"
          message="SavingDataError"
          time={2000}
          handleClose={() => dispatch(uiCloseErrorAlert())}
        />

        {errorMsg && (
          <MyAlert
            open={errorAlert}
            typeAlert="error"
            message={errorMsg}
            time={10000}
            handleClose={() => dispatch(uiCloseErrorAlert())}
          />
        )}
      </Box>
    </Box>
  );
};
